import classNames from 'classnames'
import React, { ReactElement, ReactNode } from 'react'
import { IconFa } from '../icon-fa'
import styles from './index.module.css'

interface Props extends Omit<React.HTMLProps<HTMLInputElement>, 'label'> {
  label?: ReactNode
  hideLabel?: boolean
}
export function FormCheckbox({ className, style, label, hideLabel, title, ...props }: Props): ReactElement {
  const checkbox = (
    <span className={styles.checkbox}>
      <input type="checkbox" {...props} />
      <span aria-hidden="true">
        <IconFa icon={['far', 'check']} />
      </span>
    </span>
  )
  return hideLabel ? (
    <div className={classNames('flex gap-2', props.disabled && styles.disabled, className)} style={style} title={title}>
      {checkbox}
    </div>
  ) : (
    <label
      className={classNames(
        'grid text-emphasis-high grid-cols-[1.25rem_auto] gap-2 items-center',
        props.disabled && styles.disabled,
        className
      )}
      style={style}
      title={title}
    >
      {checkbox}
      {label}
    </label>
  )
}
